import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const PriceLineItem = (props) => {
  const { label, price, bold, labelClass = "", priceClass = "", isLoading } = props;

  return isLoading ? (
    <div className="w-full flex items-center justify-between">
      <Skeleton className="flex-1" containerClassName="flex-1" />
    </div>
  ) : (
    <div className="w-full flex items-center justify-between">
      <div className={`price-line-item-label ${labelClass || `${(bold ? "label-14" : "text-14")}`}`}>{label}</div>
      <div className={`price-line-item-price text-black ${priceClass} ${(bold ? "heading-16" : "label-14")}`}>₹ {parseFloat(price || 0).toFixed(2)}</div>
    </div>
  )
};

export default PriceLineItem;
